import type { SVGProps } from 'react';

export const Arrow = ({ className, fill }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      className={className}
      height="5"
      viewBox="0 0 10 5"
      width="10"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 -6.10352e-05L5 4.99994L0 -6.10352e-05L10 -6.10352e-05Z"
        fill={fill}
      />
    </svg>
  );
};
